import { LoadingButton } from "@mui/lab";
import { Paper, Stack, Typography } from "@mui/material";
import React from "react";
import ReactPlayer from "react-player/lazy";
import { useDispatch, useSelector } from "react-redux";
import { deleteVideoThunk } from "store/reducers/advertisement/adsVideoSlice";

const AdVideoItem = ({ item }) => {
  const dispatch = useDispatch();
  const deleteItem = () => {
    dispatch(deleteVideoThunk(item.id));
  };
  const { loading } = useSelector((state) => state.adsVideo);
  return (
    <Paper>
      <ReactPlayer
        width="100%"
        height={200}
        url={item.video}
        controls={true}
        light={false}
      />
      <Typography sx={{ mt: 1, ml: 2, color: "text.secondary" }} variant="h5">
        {item.title}
      </Typography>
      <Stack alignItems="center" direction="column" alignContent="s">
        <LoadingButton
          loading={loading?.delete === item.id}
          variant="outlined"
          color="error"
          sx={{ margin: 1 }}
          onClick={deleteItem}
        >
          Remove
        </LoadingButton>
      </Stack>
    </Paper>
  );
};

export default AdVideoItem;
